import React from "react";
import { TemplateEditorProps, templateImageUrl } from "../utils/templatePageForm";
import { requiredMark, requireLabelStyles } from "./BaseModal";
import { Checkbox, Group, Stack, Text, Textarea, TextInput } from "@mantine/core";
import ImageDropzoneField from "./ImageDropzoneField";

interface Props extends TemplateEditorProps {
  /** '0' のクライアントには来店CVの入力項目を表示しない */
  invyServiceUse: string
}

/** 必須マーク付きのラベル */
const requiredLabel = (text: string) => (
  <>
    <span>{text}</span>
    {requiredMark}
  </>
)

const GuestTemplateEditor: React.FC<Props> = ({
  form,
  images,
  invyServiceUse,
  onUploadImage,
  onClearImage,
}) => {
  const templateType = form.values.template_type

  return (
    <Stack gap="lg">
      <TextInput
        label="キャンペーンの管理用の名称を設定してください"
        {...form.getInputProps('pageDescription')}
      />

      <ImageDropzoneField
        label="キービジュアルとして表示する画像ファイルを設定してください"
        description="※高さ500ピクセルに合わせて中央に表示されます。440×500ピクセル以上のjpgまたはpng画像を選択してください"
        value={form.values.key_visual}
        uploaded={images.KEY_VISUAL}
        defaultUrl={templateImageUrl(templateType, 'img_kv2.png')}
        onDrop={(files) => onUploadImage('KEY_VISUAL', files)}
        onClear={() => onClearImage('KEY_VISUAL')}
        error={form.errors.key_visual}
        dataPath="key_visual"
      />

      <Textarea
        label="キャッチコピーの文章を30文字以内で設定してください"
        rows={4}
        {...form.getInputProps('key_visual_text')}
      />

      <TextInput
        label="お友達が予約や申し込むボタンに記載する文言を設定してください"
        description="※例：お試しプランを予約する、無料体験に申し込む"
        placeholder="お試しプランを予約する"
        {...form.getInputProps('link_text')}
      />

      <TextInput
        label={requiredLabel('お友達が予約や申し込むボタンを押した場合に遷移するURLを設定してください')}
        styles={requireLabelStyles}
        placeholder="https://www.website.com/"
        {...form.getInputProps('link_url')}
      />

      <Textarea
        label="紹介状の利用方法を簡潔に設定してください。箇条書きがおすすめです"
        description="※この欄を空欄にした場合、使い方の欄は表示されなくなります"
        rows={5}
        {...form.getInputProps('flow_text')}
      />

      {invyServiceUse + '' !== '0' && (
        <Stack gap={8}>
          <Text size="sm" fw={500}>
            紹介されたお友達が来店時に店舗で見せるQRコードを発行する前に、入力してもらう項目を設定できます。
          </Text>
          <Group gap={24}>
            <Checkbox
              label="お名前"
              {...form.getInputProps('coming_name', { type: 'checkbox' })}
            />
            <Checkbox
              label="メールアドレス"
              {...form.getInputProps('coming_mail', { type: 'checkbox' })}
            />
            <Checkbox
              label="電話番号"
              {...form.getInputProps('coming_tel', { type: 'checkbox' })}
            />
            <Checkbox
              label="住所"
              {...form.getInputProps('coming_address', { type: 'checkbox' })}
            />
            <Checkbox
              label="会員番号"
              {...form.getInputProps('coming_other', { type: 'checkbox' })}
            />
          </Group>
        </Stack>
      )}
    </Stack>
  )
}

export default GuestTemplateEditor
